import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-tri-toggle',
    templateUrl: './tri-toggle.component.html',
    styleUrls: ['./tri-toggle.component.scss'],
    standalone: false
})
export class TriToggleComponent implements OnInit {

	constructor() { }

	public _selectedItem = 2;
	public get selectedItem() {
		return this._selectedItem;
	}
	@Input()
	public set selectedItem(value) {
		this._selectedItem = value;
	}

	@Output()
	public toggleChange = new EventEmitter<number>();

	public selectedClassName: string = 'rangeNeutral';

	ngOnInit() {
		if (this.selectedItem != undefined && this.selectedItem != null) {
			this.selectedItem = this.selectedItem;
		}
		this.loadSelectionChange();
	}

	loadSelectionChange() {
		if (this.selectedItem == 1) {
			this.selectedClassName = 'rangeFalse';
		} else if (this.selectedItem == 2) {
			this.selectedClassName = 'rangeNeutral';
		} else if (this.selectedItem == 3) {
			this.selectedClassName = 'rangeTrue';
		}
		this.selectedItem = this.selectedItem;
		this.toggleChange.emit(this.selectedItem);
	}
}
